// @ts-strict-ignore
import React from 'react'
/** @jsx jsx */
import { jsx } from 'theme-ui'
import { useComponentMeta } from '../../helpers/selectors'
import { ConditionalWrapper } from '../../../utils/conditional-wrapper'
import ConditionalHydrate from '../../helpers/conditional-hydrate'
import { Link } from '../../helpers/react'

const CenterAlignWrapper = ({ children }) => (
  <div
    sx={{
      display: 'flex',
      justifyContent: ['flex-start', 'center'],
      position: 'relative',
    }}
  >
    {children}
  </div>
)

const TrustpilotDefault = ({ options = {} }) => {
  const {
    businessId: defaultBusinessId,
    theme = 'light',
    href,
    templateIds: { default: defaultTemplateId },
  } = useComponentMeta('widgets', 'trustpilot')
  const { width = '168', height = '99', link = false, businessId, templateId } = options

  return (
    <ConditionalHydrate>
      <script
        type='text/javascript'
        src='//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js'
        defer
      />

      <ConditionalWrapper wrapper={CenterAlignWrapper}>
        <div
          className='trustpilot-widget'
          data-locale='en-GB'
          data-template-id={templateId || defaultTemplateId}
          data-businessunit-id={businessId || defaultBusinessId}
          data-style-height={`${height.replace(/px$/, '')}px`}
          data-style-width={`${width.replace(/px$/, '')}px`}
          data-theme={theme}
          sx={{ mt: 'md' }}
        >
          <Choose>
            <When condition={link}>
              <Link
                href={href}
                target='_blank'
                rel='noopener noreferrer'
                sx={{
                  display: 'inline-block',
                  minHeight: `${height.replace(/px$/, '')}px`,
                }}
              >
                Trustpilot
              </Link>
            </When>
            <Otherwise>
              <span
                sx={{
                  display: 'inline-block',
                  minHeight: `${height.replace(/px$/, '')}px`,
                }}
              >
                Trustpilot
              </span>
            </Otherwise>
          </Choose>
        </div>
      </ConditionalWrapper>
    </ConditionalHydrate>
  )
}

export default TrustpilotDefault
